import React, { useEffect, useState } from 'react';
import TextEditor from '../../../common/TextEditor';
import { getFirestore, collection, setDoc, getDocs, where, addDoc, Timestamp, query, orderBy, onSnapshot, doc } from 'firebase/firestore';
import { db, user } from '../../../../firebase';
import ThoughtCloudHeader from '../common/Header/thought-cloud-header';
import { Link } from 'react-router-dom';
import SnackBar from '../common/Snackbar/SnackBar';

const ThoughtCloudHome = () => {

    const [title, setTitle] = useState('');
    const [textEditorValue, setTextEditorValue] = useState('');
    const [status, setStatus] = useState(0);
    const [userId, setUserId] = useState("1");
    const [showSnacker, setShowSnacker] = useState(false);

    /*****************
    * ON LOAD
    *****************/
    useEffect(() => {
        document.body.classList.add('thoughtcloud');
    }, []);

    /*********************************
     * HANDLE TEXT EDITOR CHANGES
     * CALL THIS FUNCTION WHEN USER TYPES
     *********************************/
    const handleOnChange = (e) => {
        setTextEditorValue(e.target.innerHTML);
    }
    /*********************************
     * USE EFFECT TO CAPTURE TEXTEDITOR VALUE
     * 
     *********************************/
    useEffect(() => {
        //console.log(textEditorValue);
    }, [textEditorValue]);

    /*********************************
     * FIREBASE QUERY TO SAVE DATA
     *********************************/
    const addDocument = async () => {
        let data = {
            title: title,
            desc: textEditorValue,
            status: status,
            /*  date_created:Timestamp.fromDate(new Date()),
             date_modified: Timestamp.fromDate(new Date()), */
            user_id: userId
        }
        console.log(data);
        const dbRef = collection(db, 'thoughtcloud');
        console.log(dbRef);
        try {
            /* const docRef = await addDoc(collection(db, "thoughtcloud"), {
                title: title,
                desc: textEditorValue,
                status: status,
                date_created:Timestamp.fromDate(new Date()),
                date_modified: Timestamp.fromDate(new Date()),
                user_id: userId
            }); */
            const docRef = await setDoc(doc(db, "thoughtcloud", title), {
                title: title,
                desc: textEditorValue,
                status: status,
                date_created: Timestamp.fromDate(new Date()),
                date_modified: Timestamp.fromDate(new Date()),
                user_id: userId
            });
            console.log(docRef);
            setTitle('');
            setTextEditorValue(''); 
            setShowSnacker(true);
            /*  addDoc(collection(dbRef, 'thoughtcloud'), {
                 title: title,
                 desc: textEditorValue,
                 status: status,
                 date_created:Timestamp.fromDate(new Date()),
                 date_modified: Timestamp.fromDate(new Date()),
                 user_id: userId
           }).then((docref) => {
             console.log("Value successfully written!");
           }); */
            /*  db.collection("thoughtcloud")
             .doc(data)
             .set({
                 title: title,
                 desc: textEditorValue,
                 status: status,
                 date_created:Timestamp.fromDate(new Date()),
                 date_modified: Timestamp.fromDate(new Date()),
                 user_id: userId
             }).then(() => {
                 console.log("Value successfully written!");
             }).catch(function (error) {
                 console.error("Error writing Value: ", error);
               }); */
            /* if (user) {
                await setDoc(dbRef, data);
                console.log("Document has been added successfully");
            } */

            // await collection(db, 'thoughtcloud').doc(title).set(data);
        } catch (error) {
            console.log(error);
        }

        /*   .then((docRef) => {
              console.log(docRef);
              console.log("Document has been added successfully");
          })
          .catch((error) => {
              console.log(error);
          }) */
    }
    return (
        <>
            <ThoughtCloudHeader />
            <div className="grid-page-wrap">
                <div className="grid-container">
                    <div className="grid-card">
                        <div className="grid-card-header">
                            <span><h4>Capture that passing cloud</h4></span>
                        </div><br />
                        <div className="grid-card-content">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Thought Title"
                                    value={title}
                                    onChange={(e) => { setTitle(e.target.value) }}
                                />
                            </div>
                            <div className="form-group">
                                <TextEditor
                                    data={""}
                                    handleOnChange={handleOnChange}
                                />
                            </div>
                            <div className="form-group">
                                <div className="grid-align-end">
                                    <button onClick={() => {
                                        setStatus(0);
                                        addDocument();
                                    }} className="btn btn-default">Save Draft</button>&nbsp;
                                    <button onClick={() => {
                                        setStatus(1);
                                        addDocument();
                                    }} className="btn btn-primary">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        right
                    </div>
                </div>
            </div>
            {showSnacker &&
                <SnackBar type="success" msg="Cloud seeded successfully!" />
            }
        </>

    )
}
export default ThoughtCloudHome;

/*   Lost Rose
I am a lost rose in the garden,
without a rhyme or a reason.
In the night, I am lonely
As sun rise up,
My shadow is my only company 

I am found */